import Button from '@shared/components/Button/Button';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Delete } from 'assets/icons/Delete.svg';

import useDeleteRoleModal from '../WorkspaceRolesSetting/RoleSettings/useDeleteRoleModal';
import useDeleteWorkspaceRole from '../WorkspaceRolesSetting/RoleSettings/useDeleteWorkspaceRole';

interface DeleteRoleButtonProps {
  roleId: string;
  roleName: string;
  onDeleted: () => void;
}

const DeleteRoleButton = ({ roleId, roleName, onDeleted }: DeleteRoleButtonProps) => {
  const { t } = useTranslation();
  const showDeleteRoleModal = useDeleteRoleModal();
  const { canDelete } = useDeleteWorkspaceRole();

  if (!canDelete) return null;

  const handleClick = () => showDeleteRoleModal(roleId, roleName, onDeleted);

  return (
    <Button variant="destructiveTertiary" onClick={handleClick} className="!w-full sm:!w-fit">
      <div className="flex items-center gap-2">
        <Delete className="w-5 h-5 shrink-0 stroke-1.5 stroke-current" />
        {t('workspace_roles.edit.delete_button_label')}
      </div>
    </Button>
  );
};

export default DeleteRoleButton;
